/**
 * A flag for a GA4 country name ("South Africa" → 🇿🇦), as AgencyAnalytics'
 * Location rows show. The name → code map is built once from the browser's
 * own English region names, so no country list is kept here.
 */

const LETTER_A = 65;
const ALPHABET = 26;
const REGIONAL_INDICATOR_A = 0x1f1e6;
/**
 * Reserved and retired codes the browser still names after a current country
 * (DD "Germany", UK "United Kingdom", CS "Serbia", …): never the flag to show.
 */
const NOT_A_FLAG = new Set([
  'AN',
  'BU',
  'CS',
  'DD',
  'EU',
  'EZ',
  'FX',
  'NT',
  'QO',
  'SU',
  'TP',
  'UK',
  'UN',
  'YU',
  'ZR',
]);

let byName: Map<string, string> | null = null;

function names(): Map<string, string> {
  if (byName) return byName;
  byName = new Map();
  try {
    const display = new Intl.DisplayNames(['en'], { type: 'region' });
    for (let first = 0; first < ALPHABET; first += 1) {
      for (let second = 0; second < ALPHABET; second += 1) {
        const code = String.fromCharCode(LETTER_A + first, LETTER_A + second);
        const name = display.of(code);
        if (name && name !== code && !NOT_A_FLAG.has(code)) byName.set(name.toLowerCase(), code);
      }
    }
  } catch {
    // No Intl.DisplayNames: rows simply show without flags.
  }
  return byName;
}

export function countryFlag(country: string): string {
  const code = names().get(country.toLowerCase());
  if (!code) return '';
  return String.fromCodePoint(
    ...[...code].map((letter) => REGIONAL_INDICATOR_A + letter.charCodeAt(0) - LETTER_A),
  );
}
